import * as facilityActions from '../actions/facility';

export interface IFacilityState {
  communicationsEnabledChanging: boolean;
  communicationsEnabledChangeError?: Error;

  textingEnabledChanging: boolean;
  textingEnabledChangeError?: Error;

  audioCallingEnabledChanging: boolean;
  audioCallingEnabledChangeError?: Error;

  videoCallingEnabledChanging: boolean;
  videoCallingEnabledChangeError?: Error;

  musicEnabledChanging: boolean;
  musicEnabledChangeError?: Error;

  referenceMaterialEnabledChanging: boolean;
  referenceMaterialEnabledChangeError?: Error;
}
const initialState: IFacilityState = {
  communicationsEnabledChanging: false,
  textingEnabledChanging: false,
  audioCallingEnabledChanging: false,
  videoCallingEnabledChanging: false,
  musicEnabledChanging: false,
  referenceMaterialEnabledChanging: false
};

export default function (
  state: IFacilityState = initialState,
  action
): IFacilityState {
  switch (action.type) {
    case facilityActions.COMMUNICATIONS_ENABLED_CHANGING:
      return {
        ...state,
        communicationsEnabledChanging: true
      };

    case facilityActions.COMMUNICATIONS_ENABLED_CHANGE_FAILED:
      return {
        ...state,
        communicationsEnabledChanging: false,
        communicationsEnabledChangeError: action.error
      };

    case facilityActions.COMMUNICATIONS_ENABLED_CHANGED:
      return {
        ...state,
        communicationsEnabledChanging: false,
        communicationsEnabledChangeError: null
      };

    case facilityActions.TEXTING_ENABLED_CHANGING:
      return {
        ...state,
        textingEnabledChanging: true
      };

    case facilityActions.TEXTING_ENABLED_CHANGE_FAILED:
      return {
        ...state,
        textingEnabledChanging: false,
        textingEnabledChangeError: action.error
      };

    case facilityActions.TEXTING_ENABLED_CHANGED:
      return {
        ...state,
        textingEnabledChanging: false,
        textingEnabledChangeError: null
      };

    case facilityActions.AUDIO_CALLING_ENABLED_CHANGING:
      return {
        ...state,
        audioCallingEnabledChanging: true
      };

    case facilityActions.AUDIO_CALLING_ENABLED_CHANGE_FAILED:
      return {
        ...state,
        audioCallingEnabledChanging: false,
        audioCallingEnabledChangeError: action.error
      };

    case facilityActions.AUDIO_CALLING_ENABLED_CHANGED:
      return {
        ...state,
        audioCallingEnabledChanging: false,
        audioCallingEnabledChangeError: null
      };

    case facilityActions.VIDEO_CALLING_ENABLED_CHANGING:
      return {
        ...state,
        videoCallingEnabledChanging: true
      };

    case facilityActions.VIDEO_CALLING_ENABLED_CHANGE_FAILED:
      return {
        ...state,
        videoCallingEnabledChanging: false,
        videoCallingEnabledChangeError: action.error
      };

    case facilityActions.VIDEO_CALLING_ENABLED_CHANGED:
      return {
        ...state,
        videoCallingEnabledChanging: false,
        videoCallingEnabledChangeError: null
      };

    case facilityActions.MUSIC_ENABLED_CHANGING:
      return {
        ...state,
        musicEnabledChanging: true
      };

    case facilityActions.MUSIC_ENABLED_CHANGE_FAILED:
      return {
        ...state,
        musicEnabledChanging: false,
        musicEnabledChangeError: action.error
      };

    case facilityActions.MUSIC_ENABLED_CHANGED:
      return {
        ...state,
        musicEnabledChanging: false,
        musicEnabledChangeError: null
      };
    case facilityActions.REFERENCE_MATERIAL_ENABLED_CHANGING:
      return {
        ...state,
        referenceMaterialEnabledChanging: true
      };

    case facilityActions.REFERENCE_MATERIAL_ENABLED_CHANGE_FAILED:
      return {
        ...state,
        referenceMaterialEnabledChanging: false,
        referenceMaterialEnabledChangeError: action.error
      };

    case facilityActions.REFERENCE_MATERIAL_ENABLED_CHANGED:
      return {
        ...state,
        referenceMaterialEnabledChanging: false,
        referenceMaterialEnabledChangeError: null
      };
  }

  return state;
}
